<template>
  <div>
    <div class="clearfix"></div>
    <div class="row">
  <div class="col-md-12 col-sm-12 col-xs-12">
    <div class="card">
      <div class="card-header">
        <h3>{{ $t('vehicle_catalog') }}</h3>
        <div class="clearfix"></div>
      </div>
      <div class="card-content">
        <div class="col-md-12">
          <div class="form-group">
            <el-select
              :class="{
                'select-warning': !brand_id,
                'select-success': brand_id,
              }"
              class="col-md-4"
              size="large"
              :placeholder="$t('select_vehicle_brand')"
              v-model="brand_id"
              v-validate="'required'"
              name="vehicle brand"
              @change="brandChanged($event)"
            >
              <el-option
                v-for="vehiclebrand in brands"
                class="select-primary"
                :value="vehiclebrand.id"
                :label="vehiclebrand.name"
                :key="vehiclebrand.id"
              ></el-option>
            </el-select>
            <el-select
              :class="{
                'select-warning': !serie_id,
                'select-success': serie_id,
              }"
              class="col-md-4"
              size="large"
              :placeholder="$t('select_vehicle_series')"
              v-model="serie_id"
              v-validate="'required'"
              name="vehicle series"
              @change="serieChanged($event)"
            >
              <el-option
                v-for="vehicleseries in series"
                class="select-primary"
                :value="vehicleseries.id"
                :label="vehicleseries.name"
                :key="vehicleseries.id"
              ></el-option>
            </el-select>
            <el-select
              :class="{
                'select-warning': !model_id,
                'select-success': model_id,
              }"
              class="col-md-4"
              size="large"
              :placeholder="$t('select_vehicle_model')"
              v-model="model_id"
              v-validate="'required'"
              name="vehicle series"
              @change="modelChanged($event)"
            >
              <el-option
                v-for="model in models"
                class="select-primary"
                :value="model.id"
                :label="model.name"
                :key="model.id"
              ></el-option>
            </el-select>
            <div class="clearfix"></div>
          </div>
        </div>

        <table class="table table-hover">
          <thead class="text-bold">
            <tr>
              <td>{{ $t('engine_name') }}</td>
              <td>{{ $t('fuel') }}</td>
              <td>{{ $t('hp') }}</td>
              <td>{{ $t('code') }}</td>
              <td>{{ $t('read_methods') }}</td>
              <td>{{ $t('ecu') }}</td>
              <td>{{ $t('bore_stroke') }}</td>
              <td>{{ $t('optionals') }}</td>
            </tr>
          </thead>
                <tbody>
                <tr v-for="engine in engines" :key="engine.id">                  
                  <td>{{ engine.name }} </td>
                  <td> {{ engine.fuel_type }} </td>
                  <td>{{ engine.hp }}</td>
                  <td><span v-if="(engine.ecudetails) && (engine.ecudetails[0])">{{ engine.ecudetails[0].code }}</span></td>
                  <td><span v-if="(engine.ecudetails) && (engine.ecudetails[0])"><span v-for="k, rm in engine.ecudetails[0].read_methods" :key="rm">{{ rm }} |</span></span></td>
                  <td><span v-if="(engine.ecudetails) && (engine.ecudetails[0])">{{ engine.ecudetails[0].ecu_type }}</span></td>
                  <td><span v-if="(engine.ecudetails) && (engine.ecudetails[0])">{{ engine.ecudetails[0].bore_x_stroke }}</span></td>
                  <td><span v-if="(engine.ecudetails) && (engine.ecudetails[0])"><span v-for="k, eo in engine.ecudetails[0].extra_options" :key="eo">{{ eo }} |</span></span></td>
                </tr>
              </tbody>
            </table>
            <div class="clearfix"></div>
            <hr />
            <div class="btn btn-primary btn-block" @click="printWindow">{{ $t('print_list') }}</div>
            <div class="clearfix"></div>
            <br />
          </div>
        </div>
        </div>
      </div>
  </div>
</template>
<script>
import { Input, Button, Select, Option } from "element-ui";
export default {
    components: {
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data: function() {
    return {
        brands: '',
        brand_id: '',
        serie_id: '',
        series: '',
        model_id: '',
        models: '',
        engine_id: '',
        engines: '',
        brandLogoSrc: ''
    };
  },
  mounted: function() {
    this.loadVehicleTypes();
    this.loadBrands('cars');
  },
  methods: {
    printWindow() {
        window.print()
    },
    parseDetails(details) {
        if(details[0]) {
            return details[0];
        }
    },
    loadVehicleTypes() {
      Webservice.getVehicleTypes().then(resp => {
        this.vehicleData.types = resp.data;
      });
    },
    loadBrands(evt) {
      if(typeof(evt) == 'object') {
        var type = evt.target.value
      } else {
        var type = evt;
      }
      Webservice.getBrands(type).then(resp => {
        this.brands = resp.data;
      });
    },
    brandChanged(brandId) {
      Webservice.getBrandImage(brandId).then(response => {
        if(response.status == 200) {
          this.brandLogoSrc =
          "data:image/png;base64," +
          new Buffer(response.data, "binary").toString("base64");
        }
      });
      Webservice.getSeries(brandId).then(resp => {
        this.series = resp.data;
      });
    },
    serieChanged(serieId) {
      Webservice.getBuilds(serieId).then(resp => {
        this.models = resp.data;
      });
    },
    modelChanged(buildId) {
      Webservice.getEngines(buildId, true).then(resp => {
        this.engines = resp.data;
      });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Catalog.vue